import { createRouter, createWebHistory } from 'vue-router';
import AllNews from '../views/AllNews.vue';
import SubSetting from '../views/SubSetting.vue';
import GuestBook from '../views/GuestBook.vue';

const routes = [
  { path: '/', redirect: '/news' },
  { path: '/news', name: 'AllNews', component: AllNews },
  { path: '/subscribe', name: 'SubSetting', component: SubSetting },
  { path: '/guestbook', name: 'GuestBook', component: GuestBook },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;